module.exports = __webpack_public_path__ + "img/seep1.1cca8cc3.png";